// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qc8k","field":"styles_field__1DNKA","fieldCol":"styles_fieldCol__1xDnH","diffCol":"styles_diffCol__nON0j","diff":"styles_diff__1zIsm"};